var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailClassicLtr = function SvgMailClassicLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M84.437 20H15.563C12.498 20 10 22.472 10 25.506v48.988C10 77.528 12.498 80 15.563 80h68.874C87.502 80 90 77.528 90 74.494V25.506C90 22.472 87.502 20 84.437 20m-3.196 4.72h-62.08l30.763 22.93zm-66.473 2.672v47.102a.8.8 0 0 0 .795.786h68.874a.8.8 0 0 0 .795-.786V27.707L51.318 52.54a2.38 2.38 0 0 1-2.762.036l-.067-.048z",
    clipRule: "evenodd"
  })));
};
export default SvgMailClassicLtr;